import React from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';

import { below } from 'utils/breakpoint';
import { entryVerifyStatus } from 'config/entryVerifyStatus';

import useIsContestUgcModule from 'client/game_photoContest/hooks/useIsContestUgcModule';

import VerifyStatusLabel from 'client/components/verify/VerifyStatusLabel';
import UgcVoteInfo from 'client/components/Result/EntriesInfo/customResult/UgcVoteInfo';
import SerialDateInfo from 'client/components/Result/EntriesInfo/SerialDateInfo';

import CommentSettings from 'components/Comment/CommentSettings';
import AsceptRatioContainer from 'components/Comment/AsceptRatioContainer';

function ResultComment({
    isExpand,
    isMultiple,
    serialNo,
    resultCreatedAt,
    componentStyle,
    validStatus,
    resultInfo: { ugcAuthorName, mediaLibraryUuid, media } = {}
}) {
    const isContestUgcModule = useIsContestUgcModule();
    const { enableFixedAspectRatio, enableParticipantName } = useSelector(s => s.settingGame);
    const isFixed = enableFixedAspectRatio === 1;
    const { settingOptions } = useSelector(s => s.gameState);

    return (
        <SerialDateInfo id={serialNo} date={resultCreatedAt}>
            <div css={statusContainerStyle}>
                {validStatus !== entryVerifyStatus.PASSED && (
                    <VerifyStatusLabel status={validStatus} />
                )}
                <div css={toggleIconStyle}>{!isExpand && <ArrowDropDownIcon />}</div>
            </div>
            <Collapse in={isExpand} css={css(containerStyle)}>
                {Boolean(enableParticipantName) && (
                    <div css={textContainerStyle}>
                        <Typography variant="h6" css={titleStyle(componentStyle)}>
                            {ugcAuthorName}
                        </Typography>
                    </div>
                )}
                <div>
                    {media.map(({ result, promotionOptionUuid: commentBgUUID }) => {
                        const settings = settingOptions.find(({ uuid }) => uuid === commentBgUUID);
                        return isFixed ? (
                            <AsceptRatioContainer aspectRatio={7 / 10}>
                                <CommentSettings
                                    settings={settings}
                                    result={result}
                                    isFixed={isFixed}
                                    isResult={true}
                                />
                            </AsceptRatioContainer>
                        ) : (
                            <CommentSettings
                                settings={settings}
                                result={result}
                                isFixed={isFixed}
                                isResult={true}
                            />
                        );
                    })}
                    {isContestUgcModule && validStatus === entryVerifyStatus.PASSED && isExpand && (
                        <UgcVoteInfo
                            mediaLibraryUUID={mediaLibraryUuid}
                            componentStyle={componentStyle}
                        />
                    )}
                </div>
            </Collapse>
            {isMultiple && <Divider />}
        </SerialDateInfo>
    );
}

export default ResultComment;

const textContainerStyle = css`
    padding: 22px 8px;
`;

const titleStyle = (componentStyle = {}) => css`
    font-weight: 500;
    color: ${componentStyle.titleColor};
    word-break: break-all;
`;

const statusContainerStyle = css`
    padding: 8px 0;
    display: flex;
    justify-content: space-between;
`;

const toggleIconStyle = css`
    display: flex;
    align-items: center;
`;

const containerStyle = css`
    padding: 0 24px;
    margin: 0 -24px;
    ${below('sm')} {
        margin: 0 -16px;
    }
`;
